import { nectarApi } from '../api/client'

export type ProlificSessionResponse = {
  token: string
  projectId: string
  completionUrl: string
  rules: string | null
}

export const startProlificSession = (body: {
  prolificPid: string
  studyId: string
  sessionId: string
}): Promise<ProlificSessionResponse> =>
  nectarApi.post<ProlificSessionResponse>('/v1/prolific/session', body)

export const markProlificComplete = (): Promise<unknown> =>
  nectarApi.post('/v1/prolific/complete')
